export const shouldSample = (threshold: number = 0.5) => Math.random() > threshold;
